import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'mxjl-profile-center',
  name: '个人中心',
  icon: '我',
  group: '新聚浪业务组件',
  description: '展示登录状态、用户服务入口和设置入口。',
  defaultProps: {
    title: '我的',
    showLoginEntry: true,
    showServiceEntries: true,
    showSettings: true
  }
}
